module.exports = __webpack_public_path__ + "img/kotlin.99fbbf55.svg";